import '@awesome.me/webawesome/dist/components/icon/icon.js';
import '@awesome.me/webawesome/dist/styles/webawesome.css';
import { msg } from '@lit/localize';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/animation/animation.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
import { registerSW } from 'virtual:pwa-register';
import './components/App';
import './components/shared/va-alert';
import { authManager } from './services/AuthManager';
import { pushService } from './services/PushService';
import './styles/global.css';
import './utils/icons';

type ToastAlertElement = HTMLElement & {
  toast: () => void;
};

function showToast(message: string): void {
  const toast = Object.assign(document.createElement('sl-alert'), {
    variant: 'primary',
    duration: 2500,
    closable: true,
  });

  toast.textContent = message;
  document.body.appendChild(toast);
  (toast as ToastAlertElement).toast();
}

setBasePath('/node_modules/@shoelace-styÏle/shoelace/dist');

const isLocalHost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname.startsWith('192.168.') ||
  window.location.hostname.startsWith('10.') ||
  /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(window.location.hostname);

async function initApp() {
  authManager.initializeSessionMonitoring();

  const token = authManager.getAccessToken();
  if (token) {
    void pushService.ensureSubscriptionRegistered().catch(() => {
      // Ignore errors during initial subscription registration, we'll try again on the next login
    });
  }
}

initApp();

if (isLocalHost && 'serviceWorker' in navigator) {
  // In local network testing we prefer fresh assets over offline caching.
  void navigator.serviceWorker.getRegistrations().then(async (registrations) => {
    if (!registrations.length) return;

    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  });
}

if (import.meta.env.PROD) {
  registerSW({ immediate: true });

  let isRefreshing = false;
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (isRefreshing) {
      return;
    }

    isRefreshing = true;
    showToast(msg('A new version is available. Reloading now.'));
    window.setTimeout(() => {
      window.location.reload();
    }, 900);
  });
}
